export const dictionary = {

    projProject: {
        statusPending: 'OPENED',
        statusFinished: 'CLOSED',
    },
    projQuotes: {
        statusPending: 'PENDING',
        statusQuoteOK: 'QUOTE_OK',
        statusExpired: 'QUOTE_EXPIRED',
        statusDone: 'DONE',
    },
}

export const dictionaryError = {

    "login": [
        {
            code: 'LOGIN_FAILED',
            status: 401,
            name: 'authError',
            message: 'LOGIN_FAILED',
        },
        {
            code: 'LOGIN_BANNED',
            status: 401,
            name: 'authError',
            message: 'LOGIN_BANNED',
        },
        {
            code: 'SEQUELIZE',
            status: 500,
            name: 'sequelizeError',
            message: 'ERROR_API_SEQUELIZE',
        },
    ],
    
    "generic": [
        {
            code: 'Network Error', // AxiosError: Network Error
            status: 401,
            name: 'axiosError',
            message: 'ERROR_NETWORK',
        },
        {
            code: 'fileTypeError',
            status: 401,
            name: 'fileTypeError',
            message: 'ERROR_FILE_TYPE',
        },
    ],
    
    "API": [
        {
            code: 'SEQUELIZE',
            status: 500,
            name: 'sequelizeError',
            message: 'ERROR_API_SEQUELIZE',
        },
        {
            code: 'is',
            status: 500,
            name: 'validationError',
            message: 'ERROR_API_IS',
        },
        {
            code: 'NOT_FOUND',
            status: 404,
            name: 'notFoundError',
            message: 'ERROR_API_NOT_FOUND',
        }
    ]

}
